import React from 'react';
import { ThemedView, ThemedText, Theme } from '@app/theme';
import { CheckCircle } from '@sharedComponents/Icons';
import EyeIcon from '@app/assets/svg/EyeIcon';
import EyeOutlineIcon from '@app/assets/svg/EyeOutline';
import { useTheme } from '@shopify/restyle';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import { Platform } from 'react-native';

type StepperProps = {
  stepperData: any;
  isLoading?: boolean;
};

const Stepper = ({ stepperData, isLoading }: StepperProps) => {
  const {colors} = useTheme<Theme>();
  const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
  const currentStep = stepperData?.borrowerViewStepperMap?.findIndex((step : any) => step?.status === 'IN_PROGRESS') + 1;

  if (isLoading) {
    return (
      <ThemedView
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        paddingBottom="lg"
        paddingHorizontal='2xl'
        bg="bg-surface-primary"
        borderBottomColor='border-primary' 
        borderBottomWidth={1}
      >
        {[...Array(4)].map((_, index) => (
          <React.Fragment key={index}>
            <ThemedView
              flexDirection="column"
              alignItems="center"
              flex={1}
            >
              <ShimmerPlaceholder
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                  marginBottom: 6
                }}
                shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
              />
              <ShimmerPlaceholder
                style={{
                  width: 60,
                  height: 12,
                  borderRadius: 4
                }}
                shimmerColors={['#E4E7EC', '#F2F4F7', '#E4E7EC']}
              />
            </ThemedView>
            
            {index < 3 && (
              <ThemedView
                flex={3}
                height={1}
                bg="border-primary"
                mb='lg'
              />
            )}
          </React.Fragment>
        ))}
      </ThemedView>
    );
  }

  return (
    stepperData?.borrowerViewStepperMap?.length > 1 ?
    <ThemedView
      flexDirection="row"
      justifyContent={Platform.OS === 'web' ? 'space-between' : 'space-around'}
      alignItems="center"
      paddingBottom="lg"
      paddingHorizontal={Platform.OS === 'web' ? '2xl' : undefined}
      bg="bg-surface-primary"
      borderBottomColor='border-primary' 
      borderBottomWidth={1}
    >
      {stepperData?.borrowerViewStepperMap?.map((step : any, index : number) => (
        <React.Fragment key={step.id}>
          <ThemedView
            flexDirection="column"
            alignItems="center"
            flex={1}
          >
            {step?.status === 'COMPLETED' && (
              <CheckCircle size={16} color={colors['bg-action-primary']} />
            )}
            {step?.status === 'PENDING_CALLBACK' && (
              <EyeIcon size={16} />
            )}
            {step?.status === 'IN_PROGRESS' && (
              <EyeIcon color={colors['icon-action-primary']} size={16} />
            )}
            {step?.status === 'NOT_STARTED' && (
              <EyeOutlineIcon size={16} />
            )}
            <ThemedText color={currentStep >= index + 1 ? 'text-action-primary' : 'text-disabled'} variant='b5m'>{step.horizontalDisplayName}</ThemedText>

         {index < stepperData?.borrowerViewStepperMap.length - 1 && Platform.OS !== 'web' && (
            <ThemedView
              height={1}
              width={60}
              position='absolute'
              right={-30}
              top={8}
              bg={currentStep - 1 >= index + 1 ? 'bg-action-primary' : 'border-primary'}
              mb='lg'
            />
          )} 
          </ThemedView>

          {index < stepperData?.borrowerViewStepperMap.length - 1 && Platform.OS === 'web' && (
            <ThemedView
              height={1}
              flex={3}
              bg={currentStep - 1 >= index + 1 ? 'bg-action-primary' : 'border-primary'}
              mb='lg'
            />
          )} 
        </React.Fragment>
      ))}
    </ThemedView> : <ThemedView borderBottomColor='border-primary' borderBottomWidth={1} />
  );
};

export default Stepper; 
